<template>
  <div class="main-area">
    <el-page-header @back="goBack" :content="showTitle+'车辆信息'"></el-page-header>
    <el-form
      :inline="true"
      :model="formData"
      class="demo-ruleForm"
      label-width="100px"
      :rules="formRules"
      ref="formData"
      :size="GLOBAL.config.systemSize"
      element-loading-text="数据处理中...请稍等..."
      :disabled="!editableFlag"
      v-loading="loading">
      <el-row class="margin-top-20">
        <el-col :span="10">
          <el-form-item label="区域：" prop="villageCode">
            <cascader :set-props="setProps"
                      :set-size="GLOBAL.config.systemSize" maxlength="64"
                      ref="myArea"></cascader>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="车牌号：" prop="carNo">
            <el-input v-model="formData.carNo" placeholder="车牌号" maxlength="64"></el-input>
          </el-form-item>
        </el-col>
<!--        <el-col :span="10">-->
<!--          <el-form-item label="管理区域：" prop="listManageArea">-->
<!--            <cascader :set-props="setManageProps"-->
<!--                      :set-size="GLOBAL.config.systemSize" maxlength="64"-->
<!--                      ref="manageArea"></cascader>-->
<!--          </el-form-item>-->
<!--        </el-col>-->
        <el-col :span="8" v-if="editableFlag">
          <el-button v-if="source.add"
                     type="primary"
                     icon="el-icon-plus"
                     :size="GLOBAL.config.systemSize"
                     style="float: left;"
                     @click="addCarUsers">添加驾驶员
          </el-button>
        </el-col>
      </el-row>
      <el-divider content-position="left">驾驶员信息</el-divider>
      <el-table style="width: 100%"
                :data="tableData"
                element-loading-text="数据处理中...请稍等..."
                v-loading="loading">
        <!--序号-->
        <el-table-column type="index" label="序号" width="80px" align="center"/>
        <!--姓名-->
        <el-table-column prop="name" label="姓名" align="center"/>
        <!--手机号码-->
        <el-table-column prop="phoneNumber" label="手机号码" align="center"/>
        <!--状态-->
        <el-table-column prop="state" label="状态" align="center"/>
        <!--接单次数-->
        <el-table-column prop="jdNumber" label="接单次数" align="center"/>
        <!--完成次数-->
        <el-table-column prop="wcNumber" label="完成次数" align="center"/>
        <!--超时次数-->
        <el-table-column prop="outTimeNumber" label="超时次数" align="center"/>
        <!--好评率-->
        <el-table-column prop="rate" label="好评率" align="center"/>
        <!--更新时间-->
<!--        <el-table-column prop="updateTime"-->
<!--                         label="更新时间">-->
<!--          <template slot-scope="scope">-->
<!--            {{ scope.row.updateTime-->
<!--            ?$moment(scope.row.updateTime-->
<!--            ).format(GLOBAL.config.dateFormat.ymdhms):'' }}-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column prop="scope" label="操作" align="center" v-if="editableFlag">-->
<!--          <template slot-scope="scope">-->
<!--            <el-button icon="el-icon-delete" type="text" @click.native="handleDelete(scope.row)">删除-->
<!--            </el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
      <el-pagination
        class="margin-top-10 margin-bottom-20"
        @size-change="tableSizeChange"
        @current-change="currentChange"
        :current-page="pagination.currentPage"
        :page-sizes="pagination.pageSizeList"
        :page-size="pagination.pageSize"
        :layout="pagination.layout"
        :total="pagination.total">
      </el-pagination>
      <el-row class="margin-top-20">
        <el-button @click="goBack" style="margin: 0 20px;" :size="GLOBAL.config.systemSize">关闭</el-button>
        <el-button v-if="editableFlag" type="primary" @click="saveForm" style="margin: 0 20px;"
                   :size="GLOBAL.config.systemSize">保存
        </el-button>
      </el-row>
    </el-form>
    <!--操作-->
<!--    <addCarUserTemplate ref="addCarUserTemplate" :refresh="getTableData"/>-->
  </div>
</template>
<script>
    // import addCarUserTemplate from '.././villager/VillagerSimpleTableDialog'
    import cascader from '../../../components/Cascader'

    export default {
        name: 'CarsInfo',
        props: {
            id: {
                type: String
            },
            refresh: {
                type: Function
            },
            closeSelf: {
                type: Function
            }
        },
        data () {
            return {
                searchForm: {
                    carNo: ''
                },
                formData: {
                    id: '',
                    villageCode: '',
                    carNo: '',
                    listManageArea: []
                },
                // 校验规则
                formRules: {
                    // villageCode: [
                    //     {required: true, message: '请设置所属区域', trigger: 'blur'}
                    // ],
                    // carNo: [
                    //     {required: true, message: '请设置所属区域', trigger: 'blur'}
                    // ],
                    // listManageArea: [
                    //     {required: true, message: '请设置所属区域', trigger: 'blur'}
                    // ]
                },
                tableData: [
                  { name: '张三', phoneNumber: '123', state: '是', jdNumber: 100, wcNumber: 98, outTimeNumber: 1, rate: '99%' },
                  {name: '李四', phoneNumber: '456', state: '否', jdNumber: 90, wcNumber: 55, outTimeNumber: 2, rate: '97%'},
                  {name: '王五', phoneNumber: '789', state: '是', jdNumber: 60, wcNumber: 66, outTimeNumber: 0, rate: '96%'}
                ],
                // 分页参数
                pagination: {
                    pageSizeList: [10, 20, 30, 40, 50],
                    pageSize: 10,
                    layout: 'total, sizes, prev, pager, next, jumper',
                    total: 0,
                    currentPage: 1
                },
                // 资源权限控制，有的系统不需这么细，则全部为true
                source: {
                    add: true,
                    deleteBatch: true,
                    export: true,
                    import: true,
                    infoView: true,
                    infoEdit: true,
                    infoDelete: true
                },
                // 管理区域
                setManageProps: {
                    multiple: true, // 多选
                    checkStrictly: true, // 父节点取消选中关联
                    value: 'code',
                    label: 'name',
                    children: 'children',
                    leaf: 'leaf'
                },
                // 所属区域
                setProps: {
                    multiple: false, // 单选
                    checkStrictly: true, // 父节点取消选中关联
                    value: 'code',
                    label: 'name',
                    children: 'children',
                    leaf: 'leaf'
                },
                // 字典数据
                dictionary: {},
                loading: false,
                editableFlag: false,
                showTitle: '查看'
            }
        },
        mounted () {
            this.init()
        },
        components: {
            // addCarUserTemplate,
            cascader
        },
        methods: {
            init: function () {
                let _this = this
                if (this.$route.params) {
                    let carInfo = this.$route.params.carInfo
                    _this.formData.id = carInfo.id
                    _this.formData.villageCode = carInfo.villageCode
                    _this.formData.carNo = carInfo.carNo
                    _this.searchForm.carNo = carInfo.carNo
                    let type = this.$route.params.type
                    if (type === 'add') {
                        this.showTitle = '新增'
                    } else if (type === 'edit') {
                        this.showTitle = '编辑'
                        this.editableFlag = true
                    } else if (type === 'view') {
                        this.showTitle = '查看'
                    }
                    // 调用级联组建内 init 方法重组默认值
                    setTimeout(function () {

                        _this.$refs.myArea.init(_this.formData.villageCode)
                    }, 100)
                    this.getManageArea()
                    this.getTableData('init')
                }
            },
            goBack: function () {
                this.$router.go(-1)
            },
            // 添加驾驶员
            addCarUsers: function () {
                // let _this = this
                // if (_this.formData.carNo) {
                //     _this.$refs.addCarUserTemplate.init(_this.formData.carNo, _this.GLOBAL.config.userType.driver, false)
                // }
            },
            // 删除驾驶员
            handleDelete: function (rowData) {
                // let _this = this
                // _this.$confirm('确认删除当前驾驶员？？', '提示', {
                //     confirmButtonText: '确定',
                //     cancelButtonText: '取消',
                //     type: 'warning'
                // }).then(() => {
                //     _this.loading = true
                //     let params = {
                //         id: rowData.id,
                //         userType: _this.GLOBAL.config.userType.driver
                //     }
                //     _this.FUNCTIONS.systemFunction.interactiveData(
                //         _this,
                //         _this.GLOBAL.config.businessFlag.rtUser,
                //         _this.GLOBAL.config.handleType.removeUserRole,
                //         params,
                //         null,
                //         resultData => {
                //             _this.loading = false
                //             if (resultData) {
                //                 _this.$message.success('删除成功～')
                //                 _this.getTableData('init')
                //             } else {
                //                 _this.$message.warning('删除失败～')
                //             }
                //         }
                //     )
                // })
            },
            // 获取管理区域
            getManageArea: function () {
                // let _this = this
                // _this.FUNCTIONS.systemFunction.interactiveData(
                //     _this,
                //     _this.GLOBAL.config.businessFlag.rtManageArea,
                //     _this.GLOBAL.config.handleType.getListByCondition,
                //     {"targetId": _this.formData.id},
                //     null,
                //     resultData => {
                //         _this.loading = false
                //         if (resultData) {
                //             // 结果参数赋值
                //             let manageAreaIds = []
                //             resultData.forEach(item => {
                //                 manageAreaIds.push(item.orgCode)
                //             })
                //             _this.formData.listManageArea = manageAreaIds
                //             // 调用级联组建内 init 方法重组默认值
                //             setTimeout(function () {
                //                 _this.$refs.manageArea.init(manageAreaIds.join(','))
                //             }, 100)
                //         }
                //     }
                // )
            },
            // 获取列表
            getTableData: function (initPageFlag) {
                // this.loading = true
                // let _this = this, searchParams = this.searchForm
                // _this.FUNCTIONS.systemFunction.removeNullFields(searchParams)
                // let paginationData = _this.FUNCTIONS.systemFunction.paginationSet(
                //     initPageFlag ? 1 : _this.pagination.currentPage,
                //     initPageFlag ? 10 : _this.pagination.pageSize,
                //     searchParams)
                // // 3、 调接口获取数据
                // _this.FUNCTIONS.systemFunction.interactiveData(
                //     _this,
                //     _this.GLOBAL.config.businessFlag.rtUser,
                //     _this.GLOBAL.config.handleType.getPage,
                //     paginationData,
                //     null,
                //     resultData => {
                //         _this.loading = false
                //         if (resultData) {
                //             // 结果参数赋值
                //             _this.pagination.pageSize = resultData.size
                //             _this.pagination.total = resultData.total
                //             _this.pagination.currentPage = resultData.current
                //             resultData.records.forEach(item => {
                //                 item.orgName = _this.FUNCTIONS.systemFunction.getAreaName(_this, item.villageCode)
                //             })
                //             _this.tableData = resultData.records
                //         } else {
                //             _this.$message.warning('获取列表数据失败～')
                //         }
                //     },
                //     () => {
                //         _this.loading = false
                //     }
                // )
            },
            // 分页方法
            tableSizeChange: function (pageSize) {
                this.pagination.pageSize = pageSize
                this.getTableData()
            },
            currentChange: function (current) {
                this.pagination.currentPage = current
                this.getTableData()
            },
            saveForm: function () {
                // let _this = this
                // // 参数处理======start==========
                // let myAreaCode = this.$refs.myArea.sendToParent('value')

                // if (!myAreaCode) {
                //     this.$message.warning('请勾选区域～')
                //     return
                // }
                //
                // let checkedNode = _this.$refs.manageArea.sendToParent('obj')
                // if (!checkedNode) {
                //     _this.$message.warning('请勾选区域～')
                //     return
                // }
                // let checkedAreaId = []
                // checkedNode.forEach(item => {
                //     checkedAreaId.push({"orgCode": item.code, "orgId": item.id})
                // })
                // _this.formData.villageCode = myAreaCode
                // _this.formData.listManageArea = checkedAreaId
                // // 参数处理======end============
                // _this.loading = true
                // let params = this.formData
                // _this.FUNCTIONS.systemFunction.interactiveData(
                //     _this,
                //     _this.GLOBAL.config.businessFlag.rtCar,
                //     _this.GLOBAL.config.handleType.updateAll,
                //     _this.FUNCTIONS.systemFunction.removeNullFields(params),
                //     null,
                //     resultData => {
                //         _this.loading = false
                //         if (resultData) {
                //             _this.$message.success('保存成功～')
                //             this.$router.push({
                //                 name: 'Cars'
                //             })
                //         } else {
                //             _this.$message.warning('保存失败～')
                //         }
                //     },
                //     () => {
                //         _this.loading = false
                //     })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/view/system/car/CarsInfo.vue